import React from 'react';
import { LOOM_ID_RE } from './trainingPlan';

// Responsive Loom iframe (56.25% padding trick), lifted from the proven pattern
// in components/Playbook/OnboardingTraining/ExampleSalesMeetings.jsx. The src is
// always constructed from a validated bare id, never from a stored URL, so the
// company record can't point this iframe anywhere but loom.com/embed/{id}.
const LoomEmbed = ({ loomId, title }) => {
  if (!loomId || !LOOM_ID_RE.test(loomId)) return null;
  return (
    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, marginBottom: '12px' }}>
      <iframe
        title={title || 'Multiply training video'}
        src={`https://www.loom.com/embed/${loomId}`}
        frameBorder="0"
        allowFullScreen
        referrerPolicy="no-referrer"
        sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '8px' }}
      />
    </div>
  );
};

export default LoomEmbed;
